module.exports = __webpack_public_path__ + "img/saniy.29e4ffc6.png";